module.exports = __webpack_public_path__ + "media/images/background-11-75fa58e547cc92fd22efd341dd74d589.svg";